import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resultsApi } from '../resultsApi';

export const useUpdateResultCompletedAt = (competitionId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, completedAt }: { id: number; completedAt: string }) =>
      resultsApi.updateCompletedAt(id, completedAt),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'results', competitionId] });
    },
  });
};
